import styled from 'styled-components';
import { COLORS } from '@/styles/colors';
import { dashedLine } from '@/styles/common';
import { CardDetailsWrapper } from '@/bundle/_MasterAdmin/_BillingPage/ui/styles';
import { BREAKPOINTS } from '@/styles/responsive';

export const PricingPlanCardWrapper = styled(CardDetailsWrapper)<{ isSelected?: boolean }>`
  width: 282px;
  flex-grow: 0;

  @media only screen and (max-width: ${BREAKPOINTS.sm}px) {
    width: 100%;
  }

  ${({ isSelected }) =>
    isSelected &&
    `
    background: linear-gradient(180deg, #B8F1E7 -5.35%, #FFF 15.83%), #FFF;
    `}
`;

export const DashedLine = styled.div`
  ${dashedLine};
`;

export const OverageRateBlock = styled.div`
  background-color: ${COLORS.grey[150]};
  padding: 12px;
  border-radius: 8px;
`;
